<template>
  <q-card class="integration-card" flat bordered>
    <div class="bg-secondary text-white text-weight-bold q-pa-md flex justify-between items-center rounded-top">
      <div class="flex items-center">
        <q-icon name="cable" class="q-mr-sm" size="20px" />
        <span class="text-subtitle1 text-weight-bold">{{ integration.name }}</span>
      </div>
      <!-- Status Badge -->
      <div>
        <q-badge
          :color="integration.status === 'active' ? 'positive' : 'grey-7'"
          class="text-weight-bold q-pa-xs"
        >
          {{ integration.status === 'active' ? $t('userPanel.apiIntegrations.active') : $t('userPanel.apiIntegrations.deactivated') }}
        </q-badge>
      </div>
    </div>

    <!-- Details Section -->
    <q-card-section class="q-pt-md">
      <div class="text-caption text-grey-8 q-mb-xs">
        <q-icon name="language" class="q-mr-xs" size="16px" />
        {{ $t('userPanel.apiIntegrations.domain') }}:
        <span class="text-weight-bold text-black">{{ integration.domain }}</span>
      </div>

      <div class="text-caption text-grey-8 q-mb-xs">
        <q-icon name="vpn_key" class="q-mr-xs" size="16px" />
        {{ $t('userPanel.apiIntegrations.keyPreview') }}:
        <span class="key-preview-text text-weight-bold text-grey-9">{{ integration.key_preview }}</span>
      </div>

      <div class="text-caption text-grey-8 q-mb-xs flex items-center">
        <q-icon
          :name="integration.show_all_events ? 'visibility' : 'visibility_off'"
          size="16px"
          :color="integration.show_all_events ? 'primary' : 'grey-6'"
          class="q-mr-xs"
        />
        {{ $t('userPanel.apiIntegrations.showAllEvents') }}:
        <span class="text-weight-bold q-ml-xs text-black">
          {{ integration.show_all_events ? $t('common.yes') : $t('common.no') }}
        </span>
      </div>

      <div class="text-caption text-grey-8 q-mb-xs">
        <q-icon name="event" class="q-mr-xs" size="16px" />
        {{ $t('userPanel.apiIntegrations.created') }}:
        <span class="text-weight-bold text-black">{{ formatDate(integration.created_at) }}</span>
      </div>

      <div v-if="integration.status === 'active'" class="text-caption text-grey-8 q-mb-xs">
        <q-icon name="schedule" class="q-mr-xs" size="16px" />
        {{ $t('userPanel.apiIntegrations.lastUsed') }}:
        <span class="text-weight-bold text-black">
          {{ integration.last_used_at ? formatDate(integration.last_used_at) : $t('userPanel.apiIntegrations.neverUsed') }}
        </span>
      </div>

      <div v-if="integration.status === 'revoked'" class="text-caption text-grey-8 q-mb-xs text-negative">
        <q-icon name="block" class="q-mr-xs" size="16px" color="negative" />
        {{ $t('userPanel.apiIntegrations.deactivatedAt') }}:
        <span class="text-weight-bold">{{ formatDate(integration.revoked_at) }}</span>
      </div>
    </q-card-section>

    <q-separator />

    <q-card-actions align="right" class="q-px-md button-actions-container">
      <template v-if="integration.status === 'active'">
        <AppActionButton
          type="rotate"
          icon="refresh"
          :label="$t('userPanel.apiIntegrations.actions.rotate')"
          @click="$emit('rotate', integration)"
        />
        <AppActionButton
          type="cancel"
          icon="block"
          :label="$t('userPanel.apiIntegrations.actions.deactivate')"
          @click="$emit('deactivate', integration)"
        />
      </template>
      <template v-else>
        <AppActionButton
          type="accept"
          icon="check_circle"
          :label="$t('userPanel.apiIntegrations.actions.reactivate')"
          @click="$emit('reactivate', integration)"
        />
      </template>
    </q-card-actions>
  </q-card>
</template>

<script>
import moment from "moment";
import AppActionButton from "@/components/AppActionButton.vue";

export default {
  name: "ApiIntegrationCard",
  components: {
    AppActionButton
  },
  props: {
    integration: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD-MM-YYYY HH:mm") : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.integration-card {
  border-radius: 12px;
  background-color: #fff;
}

.rounded-top {
  border-top-left-radius: 11px;
  border-top-right-radius: 11px;
}

.key-preview-text {
  font-family: 'Courier New', Courier, monospace;
  letter-spacing: 0.5px;
}

.button-actions-container :deep(.bookings-action-button) {
  margin: 4px;
}
</style>
